import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function CopyField({ value, title="Copy" }) {
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation()

  const handleCopy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="input-group">
      <input
        type="text"
        className="form-control"
        value={value}
        readOnly
      />

      <div className="input-group-append">
        <button
          className="btn btn-outline-secondary"
          type="button"
          onClick={handleCopy}
        >
          {copied ? t("Copied") : t(title)}
        </button>
      </div>
    </div>
  );
}